import { useScrollReveal } from "../hooks/useScrollReveal";
import { track } from "../../../lib/analytics";

const FAQ = [
  {
    question: "Palnia remplace-t-il Notion, Google Agenda ou Todoist ?",
    answer:
      "Palnia réunit tâches, calendrier, habitudes et timers dans une seule app. Si vous utilisez plusieurs outils pour vous organiser, Palnia les remplace en un seul endroit — avec vos données chiffrées.",
  },
  {
    question: "Mes données sont-elles vraiment protégées ?",
    answer:
      "Oui. Tout est chiffré de bout en bout avec votre mot de passe avant de quitter votre navigateur. Personne ne peut lire vos données — pas même nous.",
  },
  {
    question: "Palnia fonctionne-t-il avec Google Agenda ou Outlook ?",
    answer:
      "Pas encore — les intégrations calendrier sont prévues dans la roadmap. Pour l'instant, Palnia fonctionne en standalone, ce qui garantit un chiffrement total de vos données.",
  },
  {
    question: "Palnia est-il gratuit ?",
    answer:
      "Oui, Palnia est entièrement gratuit pendant la bêta. Inscrivez-vous et utilisez toutes les fonctionnalités sans limite.",
  },
  {
    question: "Existe-t-il une application mobile ?",
    answer:
      "Une version mobile est prévue dans la roadmap. En attendant, Palnia fonctionne sur navigateur mobile.",
  },
] as const;

export function FaqSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15, "faq");

  return (
    <section className="py-16 px-6">
      <div
        ref={ref}
        className={`max-w-3xl mx-auto transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <h2 className="text-2xl md:text-3xl font-bold text-ink">
          Questions fréquentes
        </h2>
        <div className="mt-6 space-y-2.5">
          {FAQ.map((item) => (
            <details
              key={item.question}
              className="group rounded-xl border border-border bg-surface-alt cursor-pointer"
              onToggle={(e) => {
                const opened = (e.currentTarget as HTMLDetailsElement).open;
                track("landing_faq_toggled", { question: item.question, opened });
              }}
            >
              <summary className="flex items-center justify-between px-4 py-3 cursor-pointer text-sm font-medium text-ink list-none [&::-webkit-details-marker]:hidden">
                {item.question}
                <span className="shrink-0 ml-4 text-ink-muted transition-transform duration-200 group-open:rotate-45" aria-hidden="true">+</span>
              </summary>
              <p
                className="px-4 pb-3 text-sm text-ink-muted leading-relaxed"
                onClick={(e) => {
                  const details = (e.currentTarget.parentElement) as HTMLDetailsElement;
                  details.open = false;
                }}
              >
                {item.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
